let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2Mq3f"), load("7EorR"), load("5ZaO3")]).then(() => parcelRequire('dpLKi'));